interface FractionalTime {
  days: number;
  months: number;
  years: number;
}
export const millisecondsToFractional = (milliseconds: number): FractionalTime => {
  const millisecondsInMinute = 60 * 1000;
  const millisecondsInHour = 60 * millisecondsInMinute;
  const millisecondsInDay = 24 * millisecondsInHour;
  const millisecondsInMonth = 30 * millisecondsInDay;
  const millisecondsInYear = 365 * millisecondsInDay;

  const days = Math.floor(milliseconds / millisecondsInDay);
  const months = Math.floor(milliseconds / millisecondsInMonth);
  const years = Math.floor(milliseconds / millisecondsInYear);

  if (days <= 90) {
    return {
      years: 0,
      months: 0,
      days,
    };
  } else if (months <= 24) {
    return {
      years: 0,
      months,
      days: 0,
    };
  } else {
    const remainingMillisecondsAfterYears = milliseconds % millisecondsInYear;
    const months = Math.floor(remainingMillisecondsAfterYears / millisecondsInMonth);
    const remainingMillisecondsAfterMonths = remainingMillisecondsAfterYears % millisecondsInMonth;
    const days = Math.floor(remainingMillisecondsAfterMonths / millisecondsInDay);

    return {
      years,
      months,
      days,
    };
  }
};
